import { motion, AnimatePresence } from "framer-motion"
import { RiCloseFill } from "react-icons/ri"
import { useSelector, useDispatch } from "react-redux"
import { closeModal } from "@/redux/features/modalSlice"
import * as styles from "@/styles/modules/Modal.module.scss"

const Modal = ({ children, title, onClose }) => {
  const showModal = useSelector(state => state.modalIsOpen)
  const dispatch = useDispatch()

  const animation = {
    transition: { ease: [0.3, 0, 0, 1], duration: 0.4 },
    modalFrom: { y: 16, scale: 0.9, opacity: 0 },
    modalTo: { y: 0, scale: 1, opacity: 1 },
  }

  function handleClose() {
    dispatch(closeModal())
    if (onClose) onClose()
  }

  return (
    <AnimatePresence>
      {showModal && (
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={animation.transition}
          className={styles.bkgOverlay}
        >
          <motion.div
            initial={animation.modalFrom}
            animate={animation.modalTo}
            exit={animation.modalFrom}
            transition={animation.transition}
            className={styles.modal}
          >
            {title && <div className={styles.modalHeader}>{title}</div>}
            <button className={styles.closeBtn} onClick={handleClose}>
              <RiCloseFill />
            </button>
            <div className={styles.modalContent}>{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default Modal
